<template>
  <div class="targetSplit implement_targetSplit">
    <div class="add">
      <div>
        <div class="title">学生目标</div>
        <table>
          <tbody>
            <tr style="background:#F0F9FE">
              <th colspan="4"></th>
            </tr>
            <tr>
              <td colspan="tableTitle">
                目标分数
              </td>
              <td colspan="3">
                {{studentTarget.score}}
              </td>
            </tr>
            <tr>
              <td class="tableTitle" rowspan="2">
                目标路径
              </td>
              <td>升学路径</td>
              <td>{{studentTarget.furtherWay}}</td>
            </tr>
            <tr>
              <td style="background: none">路径条件</td>
              <td colspan="2">{{studentTarget.furtherWayNeed}}</td>
            </tr>
            <tr>
               <td class="tableTitle">目标选科</td>
               <td colspan="3">{{studentTarget.chooseSubjectName}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <div class="title">学科差异</div>
        <table>
          <tbody>
          <tr style="background:#F0F9FE">
            <th>科目</th>
            <th>现阶分数</th>
            <th>目标分数</th>
            <th>进步空间</th>
          </tr>
          <tr v-for="(item,key) in difference||[]" :key="key">
            <td>{{item.name}}</td>
            <td>
              <el-input placeholder="请输入分数" v-model="item.nowMark"></el-input>
            </td>
            <td>
              <el-input placeholder="请输入分数" v-model="item.targetMark"  :disabled="item.name=='总分'?true:false"></el-input>
            </td>
            <td>
              {{item.targetMark-item.nowMark}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div style="margin-bottom: 30px">
        <div class="title" style="margin-bottom: 0">
          学期目标
          <img src="~@img/xueyezixun/public/add.png" alt="" @click="addXueqiTarget"
               style="width: 26px;position: relative;left:10px;top:2px;cursor: pointer">
        </div>
      </div>
      <ul>
        <li class="listNav" style="margin-top:0;min-height: 35px">
            <div class="button" :class="targetNumber==key?'navActive_button':null" v-for="(item,key) in target " :key="key" @click="targetNumber=key">{{item.name}}</div>
        </li>
      </ul>
      <div>
        <div v-for="(item,key) in target||[]" :key="key" v-show="targetNumber==key">
          <div style="margin-top: 20px">
            <CircleName name="学业目标:"></CircleName>
            <ul class="inputList">
              <li v-for="(item1,key1) in item.xueye||[]" :key="key1">
                <span>{{item1.name}}</span>
                <span>
                  <el-input v-model="item1.value"></el-input>
                </span>
              </li>
            </ul>
          </div>
          <div style="margin-top: 20px">
            <CircleName name="科目目标(分数/名次):"></CircleName>
            <div class="kemus">
              <table>
                <tbody>
                <tr>
                  <th>学科</th>
                  <th v-for="(item2,key2) in item.kemu" :key="key2">{{item2.name}}</th>
                </tr>
                <tr>
                  <th>目标分数</th>
                  <td v-for="(item2,key2) in item.kemu" :key="key2">
                    <el-input style="width: 60px;" type="number" v-model="item2.score"></el-input>
                  </td>
                </tr>
                <tr>
                  <th>目标名次</th>
                  <td v-for="(item2,key2) in item.kemu" :key="key2">
                    <el-input style="width: 60px;" type="number" v-model="item2.rank"></el-input>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div style="margin-top: 20px">
            <CircleName name="条件目标:"></CircleName>
            <ul class="inputList" style="padding: 0 10px;min-height: 100px;margin-bottom: 30px">
              <li style="width: 100%">
                <el-input type="textarea" v-model="item.tiaojian"></el-input>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div style="margin-top:30px">
        <SummaryTitle title="咨询记录"></SummaryTitle>
        <el-input type="textarea" v-model="remark"></el-input>
      </div>
    </div>
    <div class="bottom" style="width: 300px;margin: 40px auto;display: flex;justify-content: space-between">
      <Button name="预览"
              @handleClick="preview" :style="{borderRadius:'16px'}"></Button>
      <Button name="生成目标拆分"  @handleClick="submit" :style="{borderRadius:'16px'}"></Button>
    </div>
    <Popup v-if="popup_bool" :inter-view="interView" :get-child-data="getChildData" :getPopupBool="getPopupBool" :getPopupData="getPopupData"></Popup>
  </div>
</template>

<script>
import Popup from '@/components/xueyezixun/InterviewPopup'
import MessageTitle from '@/components/xueyezixun/MessageTitle.vue'
import CircleName from "@/components/xueyezixun/CircleName";
import SummaryTitle from "@/components/xueyezixun/SummaryTitle";
import Button from "@/components/xueyezixun/Button";
export default {
  name: "add",
  components:{MessageTitle ,CircleName,SummaryTitle,Button,Popup},
  data(){
     let data=window.sessionStorage.getItem('targetPreview')
    if(data){
      return JSON.parse(data)
    }else{
      return {
        interView:[{
          category:3,
          interViewTheme:'目标拆分'
        }],
        // popup_bool:false,
        popup_bool:true,
        studentId:sessionStorage.getItem("myStudentStudentId"),
        getChildData:true,
        childData:{},
        interViewData:{},
        //学科差异
        difference:[
          {
            name:'总分',
            nowMark:'',
            targetMark:0
          },
          {
            name:'语文',
            nowMark:'',
            targetMark:''
          },
          {
            name:'数学',
            nowMark:'',
            targetMark:''
          },
          {
            name:'外语',
            nowMark:'',
            targetMark:''
          },
          {
            name:'最优三科',
            nowMark:'',
            targetMark:''
          }
        ],
        number:0,
        targetNumber:0,
        xueqi:['初一上学期','初一下学期','初二上学期','初二下学期','初三上学期','初三下学期','高一上学期','高一下学期','高二上学期','高二下学期','高三上学期','高三下学期'],
        add:{
          name:'',
          xueye:[
            {name:'总分', value:''},
            {name:'名次', value:''},
            {name:'其他', value:''}
          ],
          kemu:[
            {name:'语文',score:'',rank:'',},
            {name:'数学',score:'',rank:''},
            {name:'外语',score:'',rank:''},
            {name:'物理',score:'',rank:''},
            {name:'化学',score:'',rank:''},
            {name:'生物',score:'',rank:''},
            {name:'历史',score:'',rank:''},
            {name:'政治',score:'',rank:''},
            {name:'地理',score:'',rank:''},
          ],
          tiaojian:'',
        },
        target:[],
        remark:'',
        planTargetId:'',
        studentTarget:{},
        saveData:{},
        name:'',
        type:'add'
      }
    }
  },
  methods:{
    getPopupBool(bool) {
      this.popup_bool= bool
    },
    getPopupData(obj){
      this.interViewData=obj
    },
    getNowXueQi(){
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.chaifenNow, {
        studentId:sessionStorage.getItem("myStudentStudentId")
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          let name = res.data.data.name;
          this.add.name=name;
          this.target.push(JSON.parse(JSON.stringify(this.add)))
          this.number=this.xueqi.indexOf(name)
        }else{

        }
      })
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.getLastPlan, {
        studentId:sessionStorage.getItem("myStudentStudentId")
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          let { difference } = this
          difference[0].targetMark=res.data.data.score
          this.studentTarget=res.data.data;
          this.difference=JSON.parse(JSON.stringify(difference))
        }else{

        }
      })
    },
    addXueqiTarget(){
     let { number,add,target,xueqi }=this;
      if(number>=11){
        this.$message.error('不可添加')
        return;
      }
      number=number+1;
      add.name=xueqi[number]
      let obj = JSON.parse(JSON.stringify(add))
      let choose = this.studentTarget.chooseSubjectName;
      if(number>=2){
        let {kemu} = obj
        let xinkemu=kemu.filter(item=>{
          if(item.name=='语文'||(item.name=='数学')||(item.name=='外语')){
            return  true
          }else{
             return choose&&choose.indexOf(item.name)>=0||true
          }

        })
        obj.kemu=xinkemu
      }
      target.push(obj)
      this.target=target
      this.number=number
      this.targetNumber=target.length-1
    },
    preview(){
      window.sessionStorage.setItem('targetPreview',JSON.stringify(this._data))
      this.$router.push({
        path:'/consultant/minestudent/main/implement/targetsplit/preview',
        query:this.$route.query
      })
    },
    submit(){
      let obj={
        studentId:this.studentId,
        interviewRecord:this.interViewData,
        target:{
          lastId:this.id,
          planTargetId:this.studentTarget.id,
          difference:JSON.stringify(this.difference),
          target:JSON.stringify(this.target),
          remark:this.remark
        }
      }
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.implement.chaifenStore,obj, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res => {
        if (res.data.code == 2000) {
          window.sessionStorage.removeItem('targetPreview')
          this.$router.push({path:'/consultant/minestudent/main/implement/targetsplit/show',query:{...this.$route.query,targetId:res.data.data.id}})
        }
      })
    }
  },
  beforeMount() {
    if(window.sessionStorage.getItem('targetPreview')){
    }else{
      this.getNowXueQi()
    }
  }
}
</script>
<style scoped lang="less">
@import "./css/index.less";
.bottom{
  text-align: center;
  margin: 30px 0;
}
.button{
  border-radius: 3px;
  margin-right: 20px;
  text-align: center;
  line-height: 32px;
  font-size: 16px;
  cursor: pointer;
  background: #ECF8FE;
  color: #1EA2EE;
  border: 1px solid #76C6F4;
  display: inline-block;
  padding: 0 20px;
  margin-bottom: 10px
}
.navActive_button{
  border: none;
  color:#fff !important;
  border-bottom: 2px solid #3d90f6 !important;
  background:linear-gradient(#3d90f6,#2CB2FF) !important;
}
</style>
<style lang="less">
.implement_targetSplit{
  textarea{
    min-height: 140px !important;
  }
  .el-input.is-disabled .el-input__inner{
    background: none;
  }
  .inputList{
    .el-input__inner{
      border:1px solid #DCDFE6 !important;
      line-height: 32px;
      height: 32px;
    }
  }
  .kemus{
    input{
      border: none;
    }
  }
}
</style>